var locale = require('../pages/login/i18n');
var hash = require('../pages/login/hash');
var domain = location.hostname.match(/\w+\.\w+$/);
var isProduction = /enhancer\.io$/.test(domain);

var isSmallScreen = $('body').width() < 720;
var projectId = (location.pathname.match(/proj\/(\d+)/) || [])[1];

var variableManager = require('./variable-manager');
var database = window.database || {};
var dbconfig = (database.connections || {})[database.default];
var BASE = location.protocol + '//data-bridge.' + domain;
var dbconfig = (database.connections || {})[database.default];
var isBridge = dbconfig && dbconfig.connectionMethod === 'bridge';

if (dbconfig && dbconfig.connectionMethod === 'bridge') {
    BASE = 'http://' + dbconfig.bridgeHost + ':' + dbconfig.bridgePort;
}

delete loginSettings.logout;

$(function() {
variableManager.init();
Enhancer.isProduction = function() {
    return false;
};
Enhancer.getBaseUrl = function() {
    return (isProduction ? '//previewer.enhancer.io/proj/'
                    : '//previewer.enhancer.cc/proj/') + projectId
};

Enhancer.getCustomInterfaceUrl = function(interfaceName, query) {
    var url = BASE + '/custom-interface/p/' + projectId + '/call/' + interfaceName
            + '?_u_t_k_=' + encodeURIComponent(window._u_t_k_)
            + '&_d_b_=' + encodeURIComponent(JSON.stringify(database))
            + '&_s_v_=' + encodeURIComponent(JSON.stringify(variableManager.getServerVars()));
    if (typeof query === 'object') {
        for (var i in query) {
            url = url + '&' + i + '=' + encodeURIComponent(query[i]);
        }
    }
    return url;
};

// captcha
var settings = loginSettings.settings;
window.captchaUrl = (isBridge ? 'http://' + dbconfig.bridgeHost + ':' + dbconfig.bridgePort
                        : (location.protocol + '//data-bridge.' + domain))
                  + '/captcha/' + (settings.veriCodeLenth || 5) 
                  + '/' + settings.veriCodeComp 
                  + '/' + (settings.colorfulCaptcha ? '1' : '0')
                  + '/' + (settings.veriCodeLevel || 1);
function refreshCode() {
    if (settings.enableVeriCode) {
        $('.captcha').attr('src', captchaUrl + '?t=' + new Date().getTime());
    }
}

// Hack login
var loginURL = isBridge ? 'http://' + dbconfig.bridgeHost + ':' + dbconfig.bridgePort + '/login'
                        : (location.protocol + '//data-bridge.' + domain + '/login')

$('.login-btn').unbind('click')
    .on('click', function() {
        $('.tips').html('').removeClass('ui-state-error');
        var uid = $('.uid').val();
        var pwd = $('.pwd').val();
        var vcode = $('.code').val();
        if (!uid || !pwd) {
            $('.tips').addClass('ui-state-error')
                .html(locale('nullTips'));
            return;
        }
        if (enableVeriCode !== false && !vcode) {
            $('.tips').addClass('ui-state-error')
                .html(locale('inputCodeTips'));
                return;
        }
        pwd = hash.digest(window.hashType, pwd);
        
        var context;
        try {
            context = loginPageSettings.beforeLogin();
        } catch (e) {
            alert(locale('exeBeforeLoginScriptError', {reason: e.message}));
            return
        }
        if (context === false) {
            return
        }
        $.ajax({
            url:  loginURL + '/' + uid + '/' + pwd,
            data: {
                code: vcode || '',
                loginSettings: JSON.stringify(loginSettings),
                serverVars: JSON.stringify(variableManager.getServerVars()),
                database: JSON.stringify(database),
                context: JSON.stringify(context || {})
            },
            type:'POST',
            dataType: 'json',
            success: function(result) {
                var ret
                try {
                    ret = loginPageSettings.afterLogin(result);
                } catch (e) {
                    alert(locale('exeAfterLoginScriptError', {reason: e.message}));
                    return
                }
                if (ret === false) {
                    return;
                }
                if (!result.success) {
                    var msg = result.code 
                        ? locale(result.code) + result.message
                        : result.message;
                    $('.tips').addClass('ui-state-error').html(msg);
                    refreshCode();
                } else {
                    variableManager.setVars(result.variables);
                    var rd = location.search.match(/redirect=([^&]+)/);
                    if (rd) {
                        return location.href = decodeURIComponent(rd[1]);
                    }
                    var href = homePageURL;
                    if (location.hash) {
                        if (isSmallScreen) {
                            href = href + location.hash.replace('#', '/m/');
                        } else {
                            href = href + location.hash
                        }
                    } else if (isSmallScreen) {
                        href = href + '/m';
                    }
                    location.href = href;
                }
            },
            error: function(e) {
                alert(locale('loginException'));
                console.error(e);
                refreshCode();
            }
        });
    });

refreshCode();

// Add tips
$('<div class="ui-state-error">')
    .css({
        position: 'absolute',
        padding: '8px 16px',
        width: '700px',
        boxSizing: 'border-box',
        top: '4px',
        left: '50%',
        fontWeight: '900',
        marginLeft: '-350px',
        textAlign: 'center',
        borderWidth: '2px'
    })
    .text(locale('loginDevTips'))
    .appendTo($('body'));
});


//////////////////
// WEBPACK FOOTER
// ./src/tools/login-hacker.js
// module id = 0
// module chunks = 2